module.exports = __webpack_public_path__ + "img/CAT_LABWARE_TOOL.28344d41.svg";